import React from 'react';
import InputWithLabelV2 from '../../../../components/composite/FormSets/InputWithLabelV2/InputWithLabelV2';

const EmailPasswordControlSet = ({
  email,
  setEmail,
  password,
  setPassword,
}) => {
  return (
    <>
      <InputWithLabelV2
        id="email"
        label="Email"
        value={email.value}
        maxLength="150"
        type="email"
        onChange={({ target: { value } }) => setEmail(value)}
      />
      
      <InputWithLabelV2
        id="password"
        label="Password"
        value={password.value}
        maxLength="72"
        type="password"
        onChange={({ target: { value } }) => setPassword(value)}
      />
    </>
  );
};

export default EmailPasswordControlSet;